import { useMemo } from 'react'

import type { InputUnitType } from 'aem-libs-ts/src/constants/unitType'

import { useMonthsSplit } from './useMonthsSplit'
import { useUnitTranslateFunction } from './useUnitTranslate'


interface UseMonthsSplitLabelConfig {
  separator?: string
}

export const useMonthsSplitLabel = (monthsCount: number, config?: UseMonthsSplitLabelConfig): string => {
  const usedConfig = config ?? { separator: ' ' }
  const { years, months } = useMonthsSplit(monthsCount)
  const { getUnitTranslate } = useUnitTranslateFunction()

  const getUnitValue = (value: number | null, unitType: InputUnitType): string => {
    return `${value} ${getUnitTranslate(value, unitType)}`
  }

  return useMemo(() => {
    if (years && months) {
      return `${getUnitValue(years, 'years')}${usedConfig.separator}${getUnitValue(months, 'months')}`
    } else if (years && !months) {
      return `${getUnitValue(years, 'years')}`
    }

    return `${getUnitValue(months, 'months')}`
  }, [monthsCount])
}
